import {
    Box,
    Button,
    FormControlLabel,
    Paper,
    Divider,
    Grid,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';
import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
const Modal7 = (props) => {
    const {t} = useTranslation();
    const [name, setName] = useState('');
    const [full_name, setFullName] = useState('');

    console.log(props);
    const handleAdd = () => {
        const data={name, full_name};
        props.onAdd(data);
        setName('');
        setFullName('');


    }

    return (
        <Paper
            elevation={12}
            sx={{
                maxWidth: 620,
                mx: 'auto',
                p: 2
            }}
        >
            <Typography
                color="textPrimary"
                variant="h6"
            >
                {t('Přidat')}
            </Typography>
            <Divider sx={{marginBottom:3}} />
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t('Jméno')}
                        required
                        value={full_name}
                        onChange={(event)=>{setFullName(event.target.value)}}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t('Právo')}
                        required

                        value={name}
                        onChange={(event)=>{setName(event.target.value)}}
                        variant="outlined"
                    />
                </Grid>


                <Grid item xs={12}>
                    <Button
                        color="primary"
                        fullWidth
                        variant="contained"
                        onClick={()=>{
                            handleAdd()
                        }}
                    >
                        {t('Uložit')}
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    )
};

export default Modal7;
